<template>
  <div class="text-center">
    <v-dialog v-model="dialog" @keydown.esc="cancel" persistent width="500">
      <v-card>
        <v-card-title>Add Function</v-card-title>
        <div class="px-4 pt-4">
          <v-form v-model="isFormValid" ref="form" lazy-validation>
            <div>
              <v-select
                v-model="selectedFunc"
                :items="funcList"
                item-value="Id"
                item-text="Name"
                label="Select function"
                outlined
                dense
              ></v-select>
            </div>
          </v-form>
        </div>
        <v-card-text>
          <p>Use: {{ this.displayUse }}</p>
          <p>Description: {{ this.displayDesc }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="cancel"> Cancel </v-btn>
          <v-btn color="primary" depressed @click.native="ok"> Ok </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'AddFunction',
  props: { calcType: String },

  data() {
    return {
      dialog: false,
      selectedFunc: null,
      funcList: [],
      isFormValid: false,
      rules: [(v) => !!v || 'Required.'],
      displayUse: null,
      displayDesc: null,
      displayFunc: null,
    };
  },

  computed: {},

  watch: {
    selectedFunc() {
      this.parseFuncInfo();
    },
  },

  mounted() {
    this.getFunctionList();
  },

  methods: {
    open() {
      this.dialog = true;
    },

    ok() {
      this.$emit('addFunction', this.displayFunc);
      this.resetValues();
      this.dialog = false;
    },

    cancel() {
      this.dialog = false;
      this.resetValues();
    },

    resetValues() {
      this.selectedFunc = null;
      this.displayFunc = null;
      this.displayDesc = null;
      this.displayUse = null;
    },

    parseFuncInfo() {
      if (this.funcList.length && this.selectedFunc) {
        const func = this.funcList.find((f) => f.Id === this.selectedFunc);

        if (func.Description && func.Description.length && func.Description.includes('|')) {
          [this.displayUse, this.displayDesc] = func.Description.split('|');
          this.displayUse = this.displayUse.trim();
          this.displayDesc = this.displayDesc.trim();
          this.displayFunc = this.displayUse;
        } else {
          this.displayDesc = func.Description;
          this.displayFunc = func.Name;
        }
      }
    },

    async getFunctionList() {
      try {
        console.log(this.calcType);
        const response = await this.$api.get(
          '/Calculation/GetFunctionList?calcType=' + this.calcType
        );

        this.funcList = response.data;
      } catch (error) {
        console.log(error.message);
      }
    },
  },
};
</script>
